<template>
    <svg :width="width" :height="width" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.00033 3.33317V0.666504L2.66699 3.99984L6.00033 7.33317V4.6665C8.20699 4.6665 10.0003 6.45984 10.0003 8.6665C10.0003 10.8732 8.20699 12.6665 6.00033 12.6665C3.79366 12.6665 2.00033 10.8732 2.00033 8.6665H0.666992C0.666992 11.6132 3.05366 13.9998 6.00033 13.9998C8.94699 13.9998 11.3337 11.6132 11.3337 8.6665C11.3337 5.71984 8.94699 3.33317 6.00033 3.33317Z" :fill="color"/>
    </svg>
</template>

<script>
export default {
  name: 'ReloadIcon',
  props: ['width','color']
}
</script>
